<div class="header">
    <h2>{{ 'quizzes.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="quizzes-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'quizzes.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'quizzes.form.name' | translate"
            [placeholder]="'quizzes.form.name.placeholder' | translate"
            inputId="name"
            testId="quizzes-add-name"
        />
    </div>

    <app-quiz-question-list
        [questions]="draftQuestions()"
        testId="quizzes-add-questions"
        (add)="onAddQuestion()"
        (remove)="onRemoveQuestion($event)"
        (reorder)="reorderQuestions($event)"
    />
</form>

<div class="footer">
    <p-button [label]="'quizzes.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="quizzes-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'quizzes.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="quizzes-add-submit"
        (onClick)="onSubmit()"
    />
</div>
